import React, { useEffect, useState } from 'react';

import CustomDateTimeRangePicker from 'components/DateTimePicker/components/CustomDateTimeRangePicker';
import DateTimePickerButton from 'components/DateTimePicker/components/DateTimePickerButton';
import OptionsDropdown from 'components/DateTimePicker/components/OptionsDropdown';
import { useDates } from 'context/DateProvider/DateProvider';
import { CUSTOM_OPTION, getCurrentOptionFromDates, OPTIONS_MAP } from 'utils/dateTimePickerOptions';

import useStyles from './DateTimePicker.styles';

// TODO: don't show custom when navigating from frames page with custom set to health page
const DateTimePicker = () => {
  const classes = useStyles();
  const { dates } = useDates();
  const [showCustomPicker, setShowCustomPicker] = useState(
    getCurrentOptionFromDates(dates.from, dates.to) === CUSTOM_OPTION
  );
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    getCurrentOptionFromDates(dates.from, dates.to)
  );

  useEffect(() => {
    setSelectedOption(getCurrentOptionFromDates(dates.from, dates.to));
    setShowCustomPicker(getCurrentOptionFromDates(dates.from, dates.to) === CUSTOM_OPTION);
  }, [dates]);

  return (
    <div className={classes.root}>
      {showCustomPicker && <CustomDateTimeRangePicker />}
      <div className={classes.overallContainer}>
        <DateTimePickerButton
          selectedOption={selectedOption}
          showOptions={showOptions}
          setShowOptions={setShowOptions}
        />
        {showOptions && (
          <OptionsDropdown
            options={OPTIONS_MAP}
            setSelectedOption={setSelectedOption}
            setShowOptions={setShowOptions}
            setShowCustomPicker={setShowCustomPicker}
          />
        )}
      </div>
    </div>
  );
};

export default DateTimePicker;
